import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Reservations = lazy(() => import("@/pages/Reservations"));
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
export const Route = createFileRoute("/reservations")({
  component: () => (
    <ProtectedRoute>
      <Reservations />
    </ProtectedRoute>
  ),
});
